import { useQuery, useQueryClient } from '@tanstack/react-query';
import { IPageFilters, Tabs, TabValue } from '../constants/Tabs';

type BaseTabState<F extends object = {}> = {
  selectedSubTab?: string;
  filters: F;
  updateCount: number;
};

export default function useTabState<T extends TabValue>(tab: T) {
  const queryClient = useQueryClient();

  const { data: state = {} as BaseTabState<IPageFilters[T]> } = useQuery({
    queryKey: ['tabState', tab],
    queryFn: () => ({}) as BaseTabState<IPageFilters[T]>,
    staleTime: Infinity,
    initialData: {
      filters: Tabs.find((t) => t.value === tab)
        ?.initialFilters as IPageFilters[T],
      selectedSubTab: Tabs.find((t) => t.value === tab)?.selectedSubTab,
      updateCount: 0,
    },
  });

  const updateTabState = (
    partialUpdate: Partial<BaseTabState<IPageFilters[T]>>,
  ) => {
    queryClient.setQueryData<BaseTabState<IPageFilters[T]>>(['tabState', tab], {
      ...state,
      ...partialUpdate,
    });
  };

  const triggerUpdate = () => {
    updateTabState({
      updateCount: state.updateCount + 1,
    });
  };

  return {
    activeSubTab: state.selectedSubTab,
    filters: state.filters,
    updateCount: state.updateCount,

    updateTabState,
    triggerUpdate,
  } as const;
}
